import React from 'react';

class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        console.log('error: ', error);
        console.log('info: ', info);

        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) {            
            return (
                <div>
                    Ha ocurrido un error procesando la solicitud
                </div>
            );            
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
